import SkyScroll from './sky-scroll';

export default SkyScroll;



// WEBPACK FOOTER //
// ./scripts/sky-scroll/index.js